import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLock = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-lock" data-icon="icon-lock" aria-hidden="true" {...props} ref={ref}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>);
});

IconLock.displayName = 'IconLock';
